import Story from "./Story";
import AppConfig from "src/config/AppConfig";
import States from "./States";

export default class Chapter {
    id:number = 1;
    name:string = "New Chapter";
    storys:Array<Story> = [new Story()];

    public static getDefaultChapter(theme:string, currentChapter:number):Chapter {
        let defaultChapter:Chapter = new Chapter();
        let defaultChapterSettings:any = AppConfig.getDefaultChapterSettings(theme);
        let storyIntro:Story = new Story();
        let objective:Story = new Story();
        let storyCharacter:Story = new Story();
        let mission:Story = new Story();
        storyIntro.id = 1;
        objective.id = 2;
        storyCharacter.id = 3;
        mission.id = 4;
        storyIntro.text = defaultChapterSettings.introText;
        objective.text = defaultChapterSettings.objectiveText;
        storyCharacter.text = defaultChapterSettings.characterText;
        mission.text = defaultChapterSettings.missionText;
        storyIntro.locked = true;
        objective.locked = true;
        storyCharacter.locked = true;
        mission.locked = true;
        storyIntro.decisions[0].decision = "Continue";
        storyIntro.decisions[0].jumpChapter = currentChapter.toString();
        storyIntro.decisions[0].jumpPage = States.nextPage;
        objective.decisions[0].decision = "Continue";
        objective.decisions[0].jumpChapter = "0";
        objective.decisions[0].jumpPage = States.nextPage;
        storyCharacter.decisions[0].decision = "Continue";
        storyCharacter.decisions[0].jumpChapter = currentChapter.toString();
        storyCharacter.decisions[0].jumpPage = States.nextPage;
        storyCharacter.decisions[0].move = "Stay";
        mission.decisions[0].decision = "Continue";
        mission.decisions[0].jumpChapter = currentChapter.toString();
        mission.decisions[0].jumpPage = States.nextPage;
        defaultChapter.storys = [storyIntro, objective, storyCharacter, mission];
        return defaultChapter;
    }    
}




// WEBPACK FOOTER //
// ./src/objects/Chapter.ts